import {Box, IconButton, ListItem, ListItemAvatar, ListItemText} from '@mui/material';
import UserAvatar from '../../common/UserAvatar';
import Tag from '../customerList/trackTimeDialog/Tag';
import {WorkingTime} from '../../../state/types/WorkingTime';
import {DateTime, Interval} from 'luxon';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {useSelector} from 'react-redux';
import {Selector} from '../../../state/selector';

interface WorkingTimeListItemProps {
    workingTime: WorkingTime;
    onEdit: () => void;
    onDelete: () => void;
    archived: boolean;
}

const WorkingTimeListItem = (props: WorkingTimeListItemProps) => {
    const isAdmin = useSelector(Selector.User.isAdmin);
    const userId = useSelector(Selector.User.userId);
    const start = DateTime.fromJSDate(props.workingTime.start);
    const end = DateTime.fromJSDate(props.workingTime.end);

    const duration = props.workingTime.durationOnly && props.workingTime.durationMinutes
        ? (props.workingTime.durationMinutes / 60).toFixed(2)
        : Interval.fromDateTimes(start, end).length('hours').toFixed(2);

    const primaryText = props.workingTime.durationOnly
        ? `${start.toFormat('dd.MM.yyyy')} - Dauer: ${duration}h`
        : `${start.toFormat('dd.MM.yyyy HH:mm')} - ${end.toFormat('dd.MM.yyyy HH:mm')} - Dauer: ${duration}h`;

    return (
        <ListItem
            divider={true}
            secondaryAction={(
                <Box>
                    <IconButton
                        disabled={(!isAdmin && props.workingTime.employeeId !== userId) || props.archived}
                        onClick={props.onEdit}
                    >
                        <EditIcon />
                    </IconButton>
                    {isAdmin &&
                        <IconButton
                            color={'error'}
                            onClick={props.onDelete}
                            disabled={props.archived}
                        >
                            <DeleteIcon />
                        </IconButton>
                    }
                </Box>
            )}
        >
            <ListItemAvatar>
                <UserAvatar userId={props.workingTime.employeeId} />
            </ListItemAvatar>
            <ListItemText
                primary={primaryText}
                secondary={
                    <Box component={'span'}>
                        {props.workingTime.tags && props.workingTime.tags.length > 0 && (
                            <Box component={'span'} sx={{ display: 'inline-flex', gap: 0.5, marginRight: 1 }}>
                                {props.workingTime.tags.map(tag => (
                                    <Tag key={tag} label={tag} />
                                ))}
                            </Box>
                        )}
                        {props.workingTime.note}
                    </Box>
                }
            />
        </ListItem>
    );
};

export default WorkingTimeListItem;
